import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';
import { CSSProperties } from 'react';

interface Props {
  progressData: {
    numberOfSteps: number;
    stepsCompleted: number;
    stepsStarted: number;
  };
  progressStyle?: CSSProperties;
  style?: CSSProperties;
}

const UserPathStepProgress = ({
  progressData,
  progressStyle,
  style
}: Props) => {
  const { messages, theme } = useReduxState();

  if (!progressData) return null;

  return (
    <div className="progress" style={style}>
      {progressData.numberOfSteps ? (
        <div className="progress-bar" style={progressStyle}>
          <ProgressBar
            labels={[
              `${progressData.stepsCompleted} ${messages.commonCompleted}`,
              `${progressData.stepsStarted - progressData.stepsCompleted} ` +
                messages.commonStarted,
              `${progressData.numberOfSteps - progressData.stepsStarted} ` +
                messages.commonNotStarted
            ]}
            labelStyle={{ color: theme.textColorLight, marginBottom: 3 }}
            progresses={[
              {
                color: theme.successColor,
                progress:
                  progressData.stepsCompleted / progressData.numberOfSteps
              },
              {
                color: 'rgba(0, 0, 0, 0.4)',
                progress: progressData.stepsStarted / progressData.numberOfSteps
              }
            ]}
          />
        </div>
      ) : (
        <div className="no-steps">{messages.pathsStepsEmpty}</div>
      )}

      <style jsx>{`
        .progress {
          display: inline-block;
        }
        .progress-bar {
          width: 100%;
        }
        .no-steps {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
          line-height: 1;
          padding: 5px 0;
          width: 100px;
        }
      `}</style>
    </div>
  );
};

export default UserPathStepProgress;
